'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dProxy$002dName$0024$0024anon$002485 from "./presto.types$-Proxy-Name$$anon$85.js";
var $p;
/** @constructor */
function $c_Lpresto_types$ProxyName$() {
  this.c9B = null;
  this.c9C = false;
  this.c9z = null;
  this.c9A = false;
  this.c9F = null;
  this.c9G = false;
  this.c9D = null;
  this.c9E = false;
}
export { $c_Lpresto_types$ProxyName$ as $c_Lpresto_types$ProxyName$ };
$p = $c_Lpresto_types$ProxyName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$ProxyName$;
/** @constructor */
function $h_Lpresto_types$ProxyName$() {
}
export { $h_Lpresto_types$ProxyName$ as $h_Lpresto_types$ProxyName$ };
$h_Lpresto_types$ProxyName$.prototype = $p;
$p.csX = (function() {
  if ((!this.c9C)) {
    this.c9B = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c9C = true;
  }
  return this.c9B;
});
$p.ae3 = (function() {
  if ((!this.c9A)) {
    this.c9z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c9A = true;
  }
  return this.c9z;
});
$p.ct9 = (function() {
  if ((!this.c9G)) {
    this.c9F = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c9G = true;
  }
  return this.c9F;
});
$p.cJB = (function() {
  if ((!this.c9E)) {
    this.c9D = new $j_presto$002etypes$0024$002dProxy$002dName$0024$0024anon$002485.$c_Lpresto_types$ProxyName$$anon$85(this);
    this.c9E = true;
  }
  return this.c9D;
});
var $d_Lpresto_types$ProxyName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$ProxyName$, "presto.types$ProxyName$", ({
  a11: 1,
  D: 1
}));
export { $d_Lpresto_types$ProxyName$ as $d_Lpresto_types$ProxyName$ };
var $n_Lpresto_types$ProxyName$;
function $m_Lpresto_types$ProxyName$() {
  if ((!$n_Lpresto_types$ProxyName$)) {
    $n_Lpresto_types$ProxyName$ = new $c_Lpresto_types$ProxyName$();
  }
  return $n_Lpresto_types$ProxyName$;
}
export { $m_Lpresto_types$ProxyName$ as $m_Lpresto_types$ProxyName$ };
//# sourceMappingURL=presto.types$-Proxy-Name$.js.map
